import { useABTesting } from 'hooks/abTesting';
import { ExpSplitVipBenefits } from '../components/auth/Registration/components/VipBenefitsRegistrationBanner/helpers';

export const useIsVipBenefits = () => {
  const isVipBenefits =
    useABTesting('exp_vip_benefits_on_registration', {
      defaultVersion: ExpSplitVipBenefits.A,
      versions: [
        {
          name: ExpSplitVipBenefits.A,
          probability: 50,
        },
        {
          name: ExpSplitVipBenefits.B,
          probability: 50,
        },
      ],
    }) === ExpSplitVipBenefits.B;

  return isVipBenefits;
};
